export default __webpack_public_path__ + "static/media/Gucci-Rhyton.63651712.jpg";